/*
  ClubBev pricing (BEV-112).

  The GoPuff products API returns `price` (the store's regular price) and `offer`
  (the ClubBev price, where a live offer exists at that store). Every price surface
  asks this one resolver what to show, so the answer cannot differ between the tile,
  the PDP, search and the carousels.

  Pricing is deliberately NOT gated on membership. Showing a non-member the regular
  price removes the reason to join, so until the UX can show them what they would be
  charged without membership, everyone sees the ClubBev price. The membership flag is
  still handed over on window.gopuffShopify.customer.clubbev for when that lands.

  What this does still decide is whether an offer is worth showing at all, and whether
  the sale price is the ClubBev price or an ordinary promo — the "ClubBev!" label
  hangs off that distinction, not off who is looking.
*/
window.clubBevPricing = (() => {
  // The ClubBev price for a product, or null when there is none to show: no live
  // offer, or an offer that is not actually a saving.
  const clubBevPrice = (product = {}) => {
    const { price, offer } = product;
    if (typeof price !== `number` || typeof offer !== `number`) return null;

    return offer > 0 && offer < price ? offer : null;
  };

  /*
    The sale price to show, and whether it is the ClubBev price.

    A script promo is a percentage off whatever the shopper actually pays, so it
    stacks on the ClubBev price where there is one and on the regular price where
    there is not. That is why this returns both halves: the label depends on which
    of the two the sale price was built from.
  */
  const salePrice = (product = {}, percentOff = 0) => {
    const clubBev = clubBevPrice(product);
    const percentage = Number(percentOff);

    if (percentage > 0) {
      const base = clubBev === null ? product.price : clubBev;

      if (typeof base === `number`) {
        return { price: base - base * (percentage / 100), isClubBevPrice: clubBev !== null };
      }
    }

    return { price: clubBev, isClubBevPrice: clubBev !== null };
  };

  return { clubBevPrice, salePrice };
})();
